module.exports = __webpack_public_path__ + "static/media/KonjoImage.ec765bf3.png";